import { Component, OnInit, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { APP_LANGS } from '../../../trash/shared/constants/Values';
import { Language } from '../../../views/layout/navbar/Langauge';
import { ChangeModeLangService } from '../../../trash/shared/services/change-mode-lang.service';

@Component({
  selector: 'app-switch-language',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './switch-language.component.html',
  styleUrl: './switch-language.component.scss'
})
export class SwitchLanguageComponent implements OnInit {
  @Input() ltrLangValue = '';
  @Input() rtlLangValue = '';
  @Input() ltrLangFlag = '';
  @Input() rtlLangFlag = '';
  languages: Language[] = APP_LANGS;
  selectedLang: Language = APP_LANGS[0];
  onThemeChange: Subject<any> = new Subject<any>();

  constructor(
    public translate: TranslateService,
    public changeModeLang: ChangeModeLangService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.languages = [
      new Language({
        name: this.ltrLangValue || 'EN',
        abbr: 'en',
        flag: this.ltrLangFlag || '../../../assets/flags/us.svg',
        dir: 'ltr'
      }),
      new Language({
        name: this.rtlLangValue || 'AR',
        abbr: 'ar',
        flag: this.rtlLangFlag || '../../../assets/flags/ar.svg',
        dir: 'rtl',
        class: 'ar-font'
      })
    ];

    const storedLang = localStorage.getItem('lang');
    const currentLang = storedLang || this.translate.getDefaultLang() || 'en';

    this.translate.use(currentLang);
    const matchedLang = this.languages.find((l) => l.abbr === currentLang);
    if (matchedLang) {
      this.selectedLang = matchedLang;
    }
  }

  /** Returns the language that will be switched to when the button is clicked. */
  get nextLang(): Language {
    return this.languages.find((l) => l.abbr !== this.selectedLang.abbr) ?? this.languages[1];
  }

  /** Translation key for the button's accessible name, e.g. "Switch to Arabic" (the visible text is just "AR"). */
  get switchLabelKey(): string {
    return this.nextLang.abbr === 'ar' ? 'GENERAL.SWITCH_TO_ARABIC' : 'GENERAL.SWITCH_TO_ENGLISH';
  }

  toggleLanguage(): void {
    this.changeCurrentLang(this.nextLang);
  }

  changeCurrentLang(lang: Language, render: boolean = true): void {
    localStorage.setItem('lang', lang.abbr);

    if (render) {
      window.location.reload();
      return;
    }

    // Soft path (no full reload)
    this.selectedLang = lang;
    this.translate.use(lang.abbr);
    this.changeModeLang.onThemeChange.next({ dir: lang.dir, lang: lang.abbr });
    document.documentElement.dir = lang.dir;
  }
}
